import { collection, doc, getDocs, orderBy, query, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export interface SchoolSummary {
  id: string;
  name?: string;
  address?: string;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'schools';

export async function listSchoolsSummary(): Promise<SchoolSummary[]> {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('name', 'asc'))
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      name: data.name,
      address: data.address,
      status: data.status,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function toggleSchoolStatus(
  id: string,
  current?: string
): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  const next = current === 'active' ? 'inactive' : 'active';
  await updateDoc(ref, { status: next });
}

